module.exports = __webpack_public_path__ + "media/images/loader-f25104b8fe6add83b13456dae1ec2e8c.gif";